export const testimonials = [
  {
    name: "Aditi & Rohan",
    quote:
      "We never expected a blind date to feel this natural. One conversation and it just… clicked. We’re genuinely grateful.",
  },
  {
    name: "Meera & Atharva",
    quote:
      "No swiping, no pressure, just a real connection. This felt so much more meaningful than any app we tried before.",
  },
  {
    name: "Kavya & Omkar",
    quote:
      "We started talking like old friends. That comfort, that ease, it’s rare. Truly a refreshing experience.",
  },
  {
    name: "Shruti & Prathamesh",
    quote:
      "Simple, genuine, and beautifully arranged. We didn’t expect to bond this fast, but we did.",
  },
];
